import { ZCheckboxGroup, ZModal, ZTypography } from "@atoms";
import React, { useState } from "react";
import "./index.less";
import { EFontWeights } from "@atoms/ZTypography/interface";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { ZInput } from "@molecules";
import { updateSurveyData } from "@/Services/User";
import DistributorsSurveyIllustration from "./assets/distributor-survey.svg";
import SurveyCompletedIllustration from "./assets/survey-completed.svg";
import Sherweb from "./assets/sherweb.png";
import Pax8 from "./assets/pax8.png";
import TDSynnex from "./assets/td-synnex.png";
import Ingram from "./assets/ingram.png";
import ALSO from "./assets/also.png";
import Westcoast from "./assets/westcoast.png";
import Appriver from "./assets/appriver.png";
import Arrow from "./assets/arrow.png";
import Bechtle from "./assets/bechtle.png";
import CMS from "./assets/cms.png";
import Exclusive from "./assets/exclusive-networks.png";
import Giacom from "./assets/giacom.png";
import Inty from "./assets/inty.png";

const useDistributorSurveyModal = () => {
	const [visible, setVisible] = useState(false);
	const [selectedDistributors, setSelectedDistributors] = useState<string[]>(
		[]
	);
	const [otherDistributors, setOtherDistributors] = useState("");
	const [showThanks, setShowThanks] = useState(false);
	const [loading, setLoading] = useState(false);

	let SurveyModal: JSX.Element | null = null;
	if (visible) {
		const options = [
			{
				label: <img src={ALSO} alt="ALSO The Technology Provider" />,
				value: "also_the_technology_provider"
			},
			{
				label: (
					<img
						src={Appriver}
						style={{ height: "26px" }}
						alt="Appriver"
					/>
				),
				value: "appriver"
			},
			{ label: <img src={Arrow} alt="Arrow" />, value: "arrow" },
			{
				label: (
					<img
						src={Bechtle}
						style={{ height: "26px" }}
						alt="Bechtle"
					/>
				),
				value: "bechtle"
			},
			{
				label: (
					<img
						src={CMS}
						style={{ height: "28px" }}
						alt="CMS Distribution"
					/>
				),
				value: "cms_distribution"
			},
			{
				label: (
					<img
						src={Exclusive}
						style={{ height: "28px" }}
						alt="Exclusive Networks"
					/>
				),
				value: "exclusive_networks"
			},
			{
				label: (
					<img src={Giacom} style={{ height: "26px" }} alt="GIACOM" />
				),
				value: "giacom"
			},
			{ label: <img src={Ingram} alt="Ingram" />, value: "ingram" },
			{ label: <img src={Inty} alt="Inty" />, value: "inty" },
			{
				label: <img src={Pax8} style={{ height: "26px" }} alt="Pax8" />,
				value: "pax8"
			},
			{ label: <img src={Sherweb} alt="Sherweb" />, value: "sherweb" },
			{
				label: <img src={TDSynnex} alt="TD Synnex" />,
				value: "td_synnex"
			},
			{
				label: <img src={Westcoast} alt="Westcoast" />,
				value: "westcoast"
			}
		];
		const onChange = (checkedValues: CheckboxValueType[]) => {
			setSelectedDistributors(checkedValues as string[]);
		};

		const handleSubmit = async () => {
			if (showThanks) {
				setVisible(false);
				return;
			}
			try {
				setLoading(true);
				let distributors: string[] = [];
				if (selectedDistributors.length) {
					distributors = selectedDistributors;
				}
				if (!!otherDistributors.trim()) {
					distributors.push(otherDistributors.trim());
				}
				// API call to submit the response
				await updateSurveyData("preferred_distributors", {
					response_data: {
						distributors
					}
				});
				setShowThanks(true);
			} catch (err) {
				console.error(err);
				// Close the modal
				setVisible(false);
			} finally {
				setLoading(false);
			}
		};

		SurveyModal = (
			<ZModal
				visible={true}
				centered
				hideCancelButton
				closable={false}
				className="distributor-survey-modal"
				okText={
					<span className="mx-3">
						{showThanks ? "Close" : "Submit"}
					</span>
				}
				modalBodyClassName="flex flex-col items-center justify-center"
				onOk={handleSubmit}
				okButtonProps={{ loading }}
			>
				{showThanks ? (
					<>
						<SurveyCompletedIllustration className="mt-25" />
						<ZTypography.ZText
							weight={EFontWeights.SEMIBOLD}
							level={5}
							colorVariant={9}
							className="mt-15"
						>
							Thank You for Sharing Your Cloud Distributors!
						</ZTypography.ZText>
						<ZTypography.ZText
							colorVariant={9}
							style={{ width: "90%" }}
							className="my-auto mt-4 text-center mb-50"
						>
							We appreciate your time in sharing your preferred
							distributors. Your feedback helps us improve and
							tailor our services to better meet your needs.
						</ZTypography.ZText>
					</>
				) : (
					<>
						<DistributorsSurveyIllustration className="mt-9" />
						<ZTypography.ZText
							weight={EFontWeights.SEMIBOLD}
							level={5}
							colorVariant={9}
							className="mt-4"
						>
							Who Are Your Preferred Cloud Distributors?
						</ZTypography.ZText>
						<ZTypography.ZText
							colorVariant={9}
							style={{ width: "90%" }}
							className="my-auto mt-4 text-center"
						>
							We'd love to know which distributors you use for
							SaaS and cloud services for resale to better tailor
							our platform to your needs. Please select all that
							apply.
						</ZTypography.ZText>
						<ZCheckboxGroup
							options={options}
							className="w-full mt-5 pl-2"
							onChange={onChange}
						/>
						<div className="flex justify-center items-center mb-4 mt-7 w-full">
							<ZTypography.ZText
								className="mr-8"
								onClick={handleSubmit}
							>
								Others
							</ZTypography.ZText>
							<ZInput
								onChange={event =>
									setOtherDistributors(event.target.value)
								}
								placeholder="Enter other distributor names..."
								className="w-73"
							/>
						</div>
					</>
				)}
			</ZModal>
		);
	}
	return {
		showDistributorsSurvey: setVisible,
		SurveyModal
	};
};

export default useDistributorSurveyModal;
